import React, { useCallback } from 'react';
import Particles from "react-particles";
import { loadSlim } from "tsparticles-slim";

const ParticlesBackground = () => {
    const particlesInit = useCallback(async engine => {
        await loadSlim(engine);
    }, []);

    return (
        <Particles
            id="tsparticles"
            init={particlesInit}
            options={{
                background: {
                    color: {
                        value: "transparent",
                    },
                },
                fpsLimit: 120,
                interactivity: {
                    events: {
                        onHover: {
                            enable: true,
                            mode: "bubble", // Changed to bubble for more interaction
                        },
                        resize: true,
                    },
                    modes: {
                        bubble: {
                            distance: 200,
                            size: 6,
                            duration: 2,
                            opacity: 0.8,
                            color: "#f59e0b" // Gold on hover
                        },
                    },
                },
                particles: {
                    color: {
                        value: ["#f59e0b", "#d946ef", "#ffffff"], // Gold, Purple, White
                    },
                    links: {
                        color: "#ffffff",
                        distance: 150,
                        enable: true,
                        opacity: 0.05, // Very subtle links
                        width: 1,
                    },
                    move: {
                        direction: "top", // Floating upwards like embers/dust
                        enable: true,
                        outModes: {
                            default: "out",
                        },
                        random: true,
                        speed: 0.8,
                        straight: false,
                    },
                    number: {
                        density: {
                            enable: true,
                            area: 800,
                        },
                        value: 50,
                    },
                    opacity: {
                        value: 0.3,
                        random: true,
                        anim: {
                            enable: true,
                            speed: 1,
                            opacity_min: 0.1,
                            sync: false
                        }
                    },
                    shape: {
                        type: "circle",
                    },
                    size: {
                        value: { min: 1, max: 3 },
                    },
                },
                detectRetina: true,
                fullScreen: {
                    enable: true,
                    zIndex: -1
                }
            }}
        />
    );
};

export default ParticlesBackground;
